import * as angular from 'angular';
import * as moment from 'moment';
import {Strings} from "../shared/config/constant.module";
import isNullOrUndefined from "../services/utility/isNullOrUndefined";

export interface DateValidators extends angular.IModelValidators {
  date: (modelValue: any, viewValue: string) => boolean;
}

export interface DateController extends angular.INgModelController {
  $validators: DateValidators;
}

export interface DateTimeValidators extends angular.IModelValidators {
  dateTime: (modelValue: any, viewValue: string) => boolean;
}

export interface DateTimeController extends angular.INgModelController {
  $validators: DateTimeValidators;
}

export interface CompareToScope extends angular.IScope {
  otherModelValue: any;
}

export interface CompareToValidators extends angular.IModelValidators {
  compareTo: (modelValue: any, viewValue: string) => boolean;
}

export interface CompareToController extends angular.INgModelController {
  $validators: CompareToValidators;
}

function isNullOrUndefinedString(value: any): boolean {
  return isNullOrUndefined(value) || value === 'null';
}

const NUMBER_REGEXP = /\d+/;
const LOWER_REGEXP = /[a-z]+/;
const UPPER_REGEXP = /[A-Z]+/;

export default angular.module('aps.validation.directives', [])
  .directive('date', (): angular.IDirective => {
    return {
      require: 'ngModel',
      link: (scope: CompareToScope,
             element: angular.IAugmentedJQuery,
             attributes: angular.IAttributes,
             ngModel: DateController) => {
        ngModel.$validators.date = (modelValue) => {
          if (modelValue) {
            return moment(modelValue, Strings.DATE_FORMAT, true).isValid();
          }
          return true;
        };
      }
    };
  })
  .directive('dateTime', (): angular.IDirective => {
    return {
      require: 'ngModel',
      link: (scope: CompareToScope,
             element: angular.IAugmentedJQuery,
             attributes: angular.IAttributes,
             ngModel: DateTimeController) => {
        ngModel.$validators.dateTime = (modelValue) => {
          if (modelValue) {
            return moment(modelValue, Strings.TIME_FORMAT, true).isValid();
          }
          return true;
        };
      }
    };
  })
  .directive('compareTo', (): angular.IDirective => {
    return {
      require: 'ngModel',
      scope: {
        otherModelValue: '=compareTo'
      },
      link: (scope: CompareToScope,
             element: angular.IAugmentedJQuery,
             attributes: angular.IAttributes,
             ngModel: CompareToController) => {

        ngModel.$validators.compareTo = (modelValue) => {
          if (modelValue) {
          /* tslint:disable:triple-equals */
          return modelValue == scope.otherModelValue;
          /* tslint:enable:triple-equals */
          }
          return true;
        };

        scope.$watch('otherModelValue', () => {
          ngModel.$validate();
        });
      }
    };
  })
  .directive('convertToNumber', (): angular.IDirective => {
    return {
      require: 'ngModel',
      link: (scope: CompareToScope,
             element: angular.IAugmentedJQuery,
             attributes: angular.IAttributes,
             ngModel: angular.INgModelController) => {

        ngModel.$parsers.push((val) => {
          if (isNullOrUndefined(val)) {
            return null;
          }
          return parseInt(val, 10);
        });
        ngModel.$formatters.push((val) => {
          if (isNullOrUndefinedString(val)) {
            return null;
          }
          return '' + val;
        });
      }
    };
  })
  .directive('convertToBoolean', (): angular.IDirective => {
    return {
      require: 'ngModel',
      link: (scope: CompareToScope,
             element: angular.IAugmentedJQuery,
             attributes: angular.IAttributes,
             ngModel: angular.INgModelController) => {
        ngModel.$parsers.push((val) => {
          return val === 'true' ? true : (val === 'false' ? false : null);
        });
        ngModel.$formatters.push((val) => {
          if (isNullOrUndefinedString(val)) {
            return null;
          }
          return val ? 'true' : 'false';
        });
      }
    };
  })
  .directive('stringToNumber', (): angular.IDirective => {
    return {
      require: 'ngModel',
      link: (scope: CompareToScope,
             element: angular.IAugmentedJQuery,
             attributes: angular.IAttributes,
             ngModel: angular.INgModelController) => {
        ngModel.$parsers.push((value) => {
          if (isNullOrUndefinedString(value)) {
            return null;
          }
          return '' + value;
        });
        ngModel.$formatters.push((value) => {
          if (isNullOrUndefined(value)) {
            return value;
          }
          return parseFloat(value);
        });
      }
    };
  })
  .directive('hasNumber', (): angular.IDirective => {
    return {
      require: 'ngModel',
      link: (scope: angular.IScope,
        element: angular.IAugmentedJQuery,
        attributes: angular.IAttributes,
        ngModel: angular.INgModelController) => {
        ngModel.$validators.hasNumber = function(modelValue, viewValue) {
          if (ngModel.$isEmpty(modelValue)) {
            return true;
          }

          if (NUMBER_REGEXP.test(viewValue)) {
            return true;
          }

          return false;
        }
      }
    }
  })
  .directive('hasLower', (): angular.IDirective => {
    return {
      require: 'ngModel',
      link: (scope: angular.IScope,
        element: angular.IAugmentedJQuery,
        attributes: angular.IAttributes,
        ngModel: angular.INgModelController) => {
        ngModel.$validators.hasLower = function(modelValue, viewValue) {
          if (ngModel.$isEmpty(modelValue)) {
            return true;
          }

          if (LOWER_REGEXP.test(viewValue)) {
            return true;
          }

          return false;
        }
      }
    }
  })
  .directive('hasUpper', (): angular.IDirective => {
    return {
      require: 'ngModel',
      link: (scope: angular.IScope,
        element: angular.IAugmentedJQuery,
        attributes: angular.IAttributes,
        ngModel: angular.INgModelController) => {
        ngModel.$validators.hasUpper = function(modelValue, viewValue) {
          if (ngModel.$isEmpty(modelValue)) {
            return true;
          }

          if (UPPER_REGEXP.test(viewValue)) {
            return true;
          }

          return false;
        }
      }
    }
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/validation.directives.ts